import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Login() {
  const { login, isAuthenticated, error } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (isAuthenticated) {
    navigate('/dashboard', { replace: true });
    return null;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await login(username, password);
      navigate('/dashboard', { replace: true });
    } catch {
      // error is set via AuthContext
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" dir="rtl"
         style={{ background: 'linear-gradient(135deg, #231308 0%, #3d2411 50%, #1a0f06 100%)' }}>
      {/* Ambient glows */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-[40rem] h-[40rem] rounded-full blur-3xl opacity-20"
             style={{ background: 'radial-gradient(circle, #c49a3c 0%, transparent 70%)' }} />
        <div className="absolute bottom-0 left-0 w-[30rem] h-[30rem] rounded-full blur-3xl opacity-10"
             style={{ background: 'radial-gradient(circle, #8a5a28 0%, transparent 70%)' }} />
      </div>

      <div className="relative max-w-sm w-full mx-4">
        {/* Logo lockup */}
        <div className="text-center mb-10">
          <img src="/icon.png" alt="דאדא"
               className="h-24 w-auto mx-auto mb-5 rounded-2xl shadow-strong" />
          <h1 className="text-cream-100 text-3xl font-light tracking-[0.3em] uppercase mb-1"
              style={{ fontFamily: "'Frank Ruhl Libre', serif" }}>
            דאדא
          </h1>
          <p className="text-espresso-400 text-xs tracking-[0.25em] uppercase font-light">
            ניהול קלייה
          </p>
        </div>

        {/* Card */}
        <div className="bg-cream-50/95 backdrop-blur-xl rounded-3xl shadow-strong border border-cream-200/50 p-8">
          <h2 className="text-espresso-900 text-xl font-semibold text-center mb-7 tracking-tight"
              style={{ fontFamily: "'Frank Ruhl Libre', serif" }}>
            התחברות
          </h2>

          {error && (
            <div className="mb-5 p-3 bg-red-50 border border-red-100 rounded-xl text-red-600 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="username"
                     className="block text-xs font-semibold text-espresso-600 mb-1.5 tracking-widest uppercase">
                שם משתמש
              </label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
                className="input"
                placeholder="הזן שם משתמש"
              />
            </div>

            <div>
              <label htmlFor="password"
                     className="block text-xs font-semibold text-espresso-600 mb-1.5 tracking-widest uppercase">
                סיסמה
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="input"
                placeholder="הזן סיסמה"
              />
            </div>

            <button
              type="submit"
              disabled={isSubmitting || !username || !password}
              className="w-full mt-2 py-3 text-sm font-semibold tracking-widest uppercase rounded-2xl transition-all duration-150 active:scale-[0.98] shadow-medium disabled:opacity-40 disabled:cursor-not-allowed"
              style={{
                background: isSubmitting || !username || !password
                  ? '#8a5a28'
                  : 'linear-gradient(135deg, #6e4420 0%, #3d2411 100%)',
                color: '#f4ebda',
                letterSpacing: '0.15em',
              }}
            >
              {isSubmitting ? 'מתחבר...' : 'התחבר'}
            </button>
          </form>

        </div>
      </div>
    </div>
  );
}

export default Login;
